export enum PackTemplate {
  crypto2021 = 67,
  nightmares = 100,
  vot = 133,
  ua1 = 134,
  ua2 = 135,
  ua3 = 136,
  ua4 = 137,
}
